import { EventsPluieApi } from '../utils/api';

export const fetchPov = async (code: any): Promise<string | null> => {
  try {
    const povResponse = await EventsPluieApi.getInstallPov(code);
    if (povResponse && povResponse.data) {
      return povResponse.data;
    } else {
      console.log("Aucun POV trouvé");
      return null;
    }
  } catch (e) {
    console.error("Erreur lors de la récupération du POV", e);
    return null;
  }
};
